module.exports = __webpack_public_path__ + "static/media/manabi_about_banner_en.a488993e.png";